import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import { ProcessActivityStatus } from '@common/enums/serviceWorkflow/processActivityStatus';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';

export function BariPreCloseProcessPrematurelyRead(): JSX.Element {
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);

    return (
        <>
            <ReadForm />
            {processActivity.status === ProcessActivityStatus.complete && (
                <Alert appearance="info">
                    De patiënt wordt niet geïncludeerd in het zorgpad. Er is een bericht naar de huisarts gestuurd.
                </Alert>
            )}
        </>
    );
}
